module.exports = "/assets/92b6d12cd7cebd2904dca1a398756fa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/EW.png
// module id = 2477
// module chunks = 0